import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getApiClient, initializeApiClient } from "../../../../Services/apiService";


export const GetAllDirectCostsCommitByStagesGuid = createAsyncThunk(
  "dropdowns/GetAllDirectCostsCommitByPR_ReportsStagesGuid",
  async (parameter, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post("api/DirectCostsCommit/GetAllDirectCostsCommitByPR_ReportsStagesGuid",parameter);

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field
      console.log(data, "agegrop");

      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);


export const AddDirectCostsCommit = createAsyncThunk(
    "dropdowns/AddDirectCostsCommit",
    async (parameter, { rejectWithValue }) => {
      try {
        await initializeApiClient();
        const apiClient = await getApiClient();
        const response = await apiClient.post("api/DirectCostsCommit/AddDirectCostsCommit",parameter);
  
        // Extract data from the response object
        const data = response.data.result; // Assuming response has a "data" field
        console.log(data, "agegrop");
  
        return data; // Return the extracted data
      } catch (error) {
        return rejectWithValue(error.message);
      }
    }
  );


  export const DeleteDirectCostsCommit = createAsyncThunk(
    "dropdowns/DeleteDirectCostsCommit",
    async (parameter, { rejectWithValue }) => {
      try {
        await initializeApiClient();
        const apiClient = await getApiClient();
        const response = await apiClient.post("api/DirectCostsCommit/DeleteDirectCostsCommit",parameter);
  
        // Extract data from the response object
        const data = response.data.result; // Assuming response has a "data" field
        console.log(data, "agegrop");
  
        return data; // Return the extracted data
      } catch (error) {
        return rejectWithValue(error.message);
      }
    }
  );

  export const UpdateForShowHideDirectCosts = createAsyncThunk(
    "dropdowns/UpdateForShowHideDirectCosts",
    async (parameter, { rejectWithValue }) => {
      try {
        await initializeApiClient();
        const apiClient = await getApiClient();
        const response = await apiClient.post("api/DirectCostsCommit/UpdateForShowHideDirectCosts",parameter);
  
        // Extract data from the response object
        const data = response.data.result; // Assuming response has a "data" field
        console.log(data, "agegrop");
  
        return data; // Return the extracted data
      } catch (error) {
        return rejectWithValue(error.message);
      }
    }
  );

const DirectCostsComments = createSlice({
  name: "DirectCostsComments",
  initialState: {
    DirectCostsCommitByStagesGuidLists: [],
    loadingDirectCostsCommitByStagesGuidLists: false,
    errorDirectCostsCommitByStagesGuidLists: null,

    AddDirectCostsCommit: [],
    loadingAddDirectCostsCommit: false,
    errorAddDirectCostsCommit: null,


    DeleteDirectCostsCommit: [],
    loadingDeleteDirectCostsCommit: false,
    errorDeleteDirectCostsCommit: null,

    UpdateForShowHideDirectCosts: [],
    loadingUpdateForShowHideDirectCosts: false,
    errorUpdateForShowHideDirectCosts: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(GetAllDirectCostsCommitByStagesGuid.pending, (state, action) => {
        state.loadingDirectCostsCommitByStagesGuidLists = true;
        state.DirectCostsCommitByStagesGuidLists = action.payload;
        state.errorDirectCostsCommitByStagesGuidLists = null;
      })
      .addCase(GetAllDirectCostsCommitByStagesGuid.fulfilled, (state, action) => {
        state.loadingDirectCostsCommitByStagesGuidLists = false;
        state.DirectCostsCommitByStagesGuidLists = action.payload; // Assuming payload has the desired data
      })
      .addCase(GetAllDirectCostsCommitByStagesGuid.rejected, (state, action) => {
        state.loadingDirectCostsCommitByStagesGuidLists = false;
        state.DirectCostsCommitByStagesGuidLists = action.payload;
      });

      ///////////////////////////////////////////////////////////////
      builder
      .addCase(AddDirectCostsCommit.pending, (state, action) => {
        state.loadingAddDirectCostsCommit = true;
        state.AddDirectCostsCommit = action.payload;
        state.errorAddDirectCostsCommit = null;
      })
      .addCase(AddDirectCostsCommit.fulfilled, (state, action) => {
        state.loadingAddDirectCostsCommit = false;
        state.AddDirectCostsCommit = action.payload; // Assuming payload has the desired data
      })
      .addCase(AddDirectCostsCommit.rejected, (state, action) => {
        state.loadingAddDirectCostsCommit = false;
        state.AddDirectCostsCommit = action.payload;
      });
       ///////////////////////////////////////////////////////////////
       builder
       .addCase(DeleteDirectCostsCommit.pending, (state, action) => {
         state.loadingDeleteDirectCostsCommit = true;
         state.DeleteDirectCostsCommit = action.payload;
         state.errorDeleteDirectCostsCommit = null;
       })
       .addCase(DeleteDirectCostsCommit.fulfilled, (state, action) => {
         state.loadingDeleteDirectCostsCommit = false;
         state.DeleteDirectCostsCommit = action.payload; // Assuming payload has the desired data
       })
       .addCase(DeleteDirectCostsCommit.rejected, (state, action) => {
         state.loadingDeleteDirectCostsCommit = false;
         state.DeleteDirectCostsCommit = action.payload;
       });

        ///////////////////////////////////////////////////////////////
        builder
        .addCase(UpdateForShowHideDirectCosts.pending, (state, action) => {
          state.loadingUpdateForShowHideDirectCosts = true;
          state.UpdateForShowHideDirectCosts = action.payload;
          state.errorUpdateForShowHideDirectCosts = null;
        })
        .addCase(UpdateForShowHideDirectCosts.fulfilled, (state, action) => {
          state.loadingUpdateForShowHideDirectCosts = false;
          state.UpdateForShowHideDirectCosts = action.payload; // Assuming payload has the desired data
        })
        .addCase(UpdateForShowHideDirectCosts.rejected, (state, action) => {
          state.loadingUpdateForShowHideDirectCosts = false;
          state.UpdateForShowHideDirectCosts = action.payload;
        });
  },
});

export default DirectCostsComments.reducer;
